import { httpsCallable } from 'firebase/functions';
import {
  functions,
  isPublicTicketAppCheckConfigured,
  isPublicTicketIntakeEnabled,
} from '../../firebase';

const MAX_TOTAL_BYTES = 6 * 1024 * 1024;
const MAX_SINGLE_BYTES = 3 * 1024 * 1024;
const MAX_FILES = 4;
const ACCEPTED_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp', 'video/mp4', 'video/webm']);

export {
  MAX_FILES,
  MAX_SINGLE_BYTES,
  MAX_TOTAL_BYTES,
  ACCEPTED_TYPES,
  isPublicTicketAppCheckConfigured,
  isPublicTicketIntakeEnabled,
};

export async function searchPublicTicketMunicipalities(prefix) {
  const result = await httpsCallable(functions, 'searchPublicTicketMunicipalities')({ prefix });
  return Array.isArray(result.data?.municipalities) ? result.data.municipalities : [];
}

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error(`Bestand ${file.name} kon niet worden gelezen.`));
    reader.onload = () => resolve(String(reader.result || '').split(',').pop());
    reader.readAsDataURL(file);
  });
}

export async function listPublicTicketRobots(municipality) {
  const result = await httpsCallable(functions, 'listPublicTicketRobots')({ municipality });
  return Array.isArray(result.data?.robots) ? result.data.robots : [];
}

export async function submitPublicTicket(input) {
  const { files: selectedFiles, ...fields } = input;
  const files = Array.from(selectedFiles || []);
  if (files.length > MAX_FILES) throw new Error(`Kies maximaal ${MAX_FILES} foto's of video's.`);
  if (files.some((file) => file.size > MAX_SINGLE_BYTES)) throw new Error('Een foto of video is maximaal 3 MB.');
  if (files.reduce((sum, file) => sum + file.size, 0) > MAX_TOTAL_BYTES) throw new Error('De totale grootte van alle bijlagen is maximaal 6 MB.');
  if (files.some((file) => !ACCEPTED_TYPES.has(file.type))) throw new Error('Gebruik JPG-, PNG-, WebP-, MP4- of WebM-bestanden.');
  const attachments = await Promise.all(files.map(async (file) => ({ name: file.name, mimeType: file.type, dataBase64: await toBase64(file) })));
  const result = await httpsCallable(functions, 'submitPublicTicket')({ ...fields, attachments });
  return result.data;
}
